exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.totals-bold[data-v-e7037bd8] {\r\n    font-weight: 600;\n}\r\n", ""]);

// exports
